var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-list-group',_vm._l((_vm.suggestions),function(s){return _c('b-list-group-item',{key:s.id,attrs:{"button":""},on:{"click":function($event){return _vm.applyPrompt(s.prompt)}}},[_vm._v(" "+_vm._s(s.prompt)+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }